export default {
  setUnreadNotifications(state, payload) {
    state.unreadNotifications = payload.notifications
  },
  setReadNotifications(state, payload) {
    state.readNotifications = payload
  },
  setAllNotifications(state, value) {
    state.allNotifications = value
  },
  addNotification(state, value) {
    state.allNotifications.push(value)
  },
  setIdUnfixNews(state, value) {
    state.idUnfixNews = value
  },
  setIdFixNews(state, value) {
    state.idFixNews = value
  },
}
